export function defaultDateFormat (){
  return ( date ) => window.moment( date ).format();
}

export function defaultDateFormatDays (){
    return ( date ) => date ? window.moment( date ).format("YYYY-MM-DD") : "";
}

export function defaultDateFormatDaysAndHours (){
    return ( date ) => date ? window.moment( date ).format("YYYY-MM-DD HH:mm") : "";
}

export function defaultDateFormatHours() {
    return ( date ) => date ? window.moment( date ).format("HH:mm") : "";
}

export function defaultDateRange() {
    return ( dates ) => dates ? dates.map(date => window.moment(date).format("DD.MM HH:mm") ).join(" - ") : "";
}

export function taskDateRange() {
    return ( dates ) => dates ? dates.map(date => window.moment( date ).format("YYYY-MM-DD HH:mm") ).join(" - ") : "";
}

export function datesDiffInDays(){
    return ( dates ) => dates ? window.moment(dates[0]).diff(window.moment(dates[1]), "days") : "";
}


// WEBPACK FOOTER //
// ./sources/filters/date.filters.js